module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/katarzyna-dolecka-saranda-5ef91ccb0d6dfffe7f36e59072249e9e.png";